import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Cart from "components/cart";
import SlidingPane from "react-sliding-pane";
import { CLOSE_CART } from "utils/action-types";
import { isDesktop } from "utils/device-detect";

const SlideCart = () => {
	const { isOpen } = useSelector((state) => state.cart);
	const dispatch = useDispatch();

	return (
		<SlidingPane
			from="right"
			width={isDesktop() ? "360px" : "90%"}
			shouldCloseOnEsc
			overlayClassName="z-50"
			isOpen={isOpen}
			hideHeader
			onRequestClose={() => dispatch({ type: CLOSE_CART })}
		>
			<Cart />
		</SlidingPane>
	);
};

export default SlideCart;
